import React, { memo } from 'react'
import Helmet from 'next/head'
import PropTypes from 'prop-types'
import { Constants } from '../../adapters/helpers/Constants';
import { customJsonstringify } from '../../adapters/helpers/Utils';

const FAQBlock = ({faqSchema}) => {
    const itemList =faqSchema?.map(({fields})=> ({     
        '@type':  `${Constants.Question}`,
        'name': `${fields?.question}`,
        'acceptedAnswer': {
        '@type': `${Constants.Answer}`,
        'text': `${fields?.answer}`
        }
    }));

    return (
        <Helmet>
            <script
            type={Constants.typeLD}
                dangerouslySetInnerHTML={{
                    __html: `{
                            "@context":"${Constants.context}",
                            "@type": "${Constants.FAQschema}",
                            "mainEntity": ${customJsonstringify(itemList)}
                        }`      
                }}
            />
        </Helmet>
    )
 }

 FAQBlock.propTypes = {
    faqSchema: PropTypes.array.isRequired
    }

export { FAQBlock }

export default memo(FAQBlock)